import { TabKeys } from 'UI/constants/entityTypes';

export const COMMON_TAB_IDS = {
  ActivityLogs: TabKeys.ActivityLogs,
  Attachments: TabKeys.Files,
  ChangeLogs: TabKeys.ChangeLogs,
  Notes: TabKeys.Notes,
  SearchProjects: TabKeys.SearchProjects
};
